import styled, { css } from 'styled-components';

import { Spacer } from '@ontruck/orc';

const titleProps = () => css`
  color: var(--greyWolf);
`;

export default styled(Spacer).attrs(() => ({}))`
  ${titleProps}
`;
